export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./project.list.vue?vue&type=template&id=24973c23&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/project/project.list.vue?vue&type=template&id=24973c23&scoped=true&
// module id = 746
// module chunks = 2